import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { CollectionContext, useCollection } from '../collections'
import useSelection from '../hooks/use-selection'
import useModelKeyName from '../hooks/use-model-key-name'

function SelectedToCollection (props) {
  const collection = useCollection()
  const selection = useSelection()
  const modelKeyName = useModelKeyName()

  const selectedCollection = observable.array()

  const tempArray = []

  if (collection && collection.length > 0) {
    collection.forEach(entry => {
      const modelKey = (typeof entry.get === 'function') ? entry.get(modelKeyName) : entry[modelKeyName]

      if (selection.isSelected(modelKey) !== props.flip) {
        tempArray.push(entry)
      }
    })
  }

  if (tempArray.length > 0) {
    selectedCollection.replace(tempArray)
  }

  return (
    <CollectionContext.Provider value={selectedCollection}>
      {props.children}
    </CollectionContext.Provider>
  )
}

SelectedToCollection.defaultProps = {
  flip: false
}

SelectedToCollection.propTypes = {
  flip: PropTypes.bool
}

export default observer(SelectedToCollection)
